export default "{% block customer_login_page %}\n<packlab-page size=\"full\">\n    \n    <customer-login-form />\n\n\n</packlab-page>\n{% endblock %}";